import { Form, Input, Checkbox, Button, Divider } from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import React from "react";
import RateLimitFields from "@src/components/LLMModels/LLMForms/RateLimitFields";

const GenAIModelForm = (_props: any) => {
    return (
        <>
            <Form.Item
                label="JWT Auth URL"
                name={["extra_data", "token_url"]}
                tooltip="Endpoint used to obtain a JWT for authentication."
                rules={[
                    { required: true, message: "Please enter the JWT Auth URL" },
                    { type: "url", message: "Please enter a valid URL" },
                ]}
            >
                <Input placeholder="https://auth.example.com/token" inputMode="url" autoComplete="off" />
            </Form.Item>

            <Form.Item
                label="Chat Completion URL"
                name={["extra_data", "request_url"]}
                tooltip="Endpoint that receives the chat completion request."
                rules={[
                    { required: true, message: "Please enter the Chat Completion URL" },
                    { type: "url", message: "Please enter a valid URL" },
                ]}
            >
                <Input placeholder="https://api.example.com/v1/chat/completions" inputMode="url" autoComplete="off" />
            </Form.Item>

            <Form.Item
                label="Credentials"
                name={["extra_data", "credentials"]}
                tooltip="Secret used to request the JWT. Leave blank to keep the existing value."
            >
                <Input.Password placeholder="Enter credentials" visibilityToggle={false} autoComplete="new-password" />
            </Form.Item>

            <Form.Item
                label="Verify SSL"
                name={["extra_data", "verify_ssl"]}
                valuePropName="checked"
                rules={[{ required: true, message: "Please specify SSL verification" }]}
            >
                <Checkbox>Verify the server's SSL certificate</Checkbox>
            </Form.Item>

            <RateLimitFields />

            <Divider titlePlacement="start">Request Payload</Divider>

            <Form.Item
                label="Parameters"
                tooltip="Extra fields merged into the request body (e.g. temperature, max_tokens). The 'messages' key is reserved."
            >
                <Form.List name={["extra_data", "request_payload_entries"]}>
                    {(fields, { add, remove }) => (
                        <>
                            {fields.map(({ key, name, ...restField }) => (
                                <div key={key} style={{ display: "flex", gap: 8, marginBottom: 8, alignItems: "baseline" }}>
                                    <Form.Item
                                        {...restField}
                                        name={[name, "key"]}
                                        rules={[
                                            { required: true, message: "Key is required" },
                                            {
                                                validator: (_, value) =>
                                                    value === "messages"
                                                        ? Promise.reject(new Error("'messages' is not allowed"))
                                                        : Promise.resolve(),
                                            },
                                        ]}
                                        style={{ flex: 1, marginBottom: 0 }}
                                    >
                                        <Input placeholder="Key (e.g. temperature)" aria-label={`Parameter ${name + 1} key`} />
                                    </Form.Item>
                                    <span aria-hidden="true">:</span>
                                    <Form.Item
                                        {...restField}
                                        name={[name, "value"]}
                                        rules={[{ required: true, message: "Value is required" }]}
                                        style={{ flex: 1, marginBottom: 0 }}
                                    >
                                        <Input placeholder="Value (e.g. 0.7)" aria-label={`Parameter ${name + 1} value`} />
                                    </Form.Item>
                                    <Button
                                        type="text"
                                        danger
                                        icon={<MinusCircleOutlined />}
                                        onClick={() => remove(name)}
                                        aria-label={`Remove parameter ${name + 1}`}
                                    />
                                </div>
                            ))}
                            <Button type="dashed" onClick={() => add()} icon={<PlusOutlined />} style={{ width: "100%" }}>
                                Add Parameter
                            </Button>
                        </>
                    )}
                </Form.List>
            </Form.Item>
        </>
    );
}

export default GenAIModelForm;
